//@ts-nocheck
import React from "react";
import classNames from "classnames";
import ProjectStatus from "lib/constants/ProjectStatus";
import { FixLater } from "types";
import { SelectInput } from "components/Input";
import { Text } from "components/Typography";
import styles from "./ProjectStatusSelector.module.scss";

export const ProjectStatusSelector = ({
  name,
  value,
  onChange,
  placeholder = "Select project status",
  appearance = "normal",
  className,
  ...otherProps
}: FixLater) => {
  const input = {
    type: "select",
    name,
    placeholder: placeholder,
    options: ProjectStatus.items,
  };

  return appearance === "inline" ? (
    <Text
      {...otherProps}
      value={value}
      canEdit={true}
      input={input}
      onConfirm={(value) => onChange(name, value)}
      className={className}
    />
  ) : (
    <SelectInput
      {...otherProps}
      input={input}
      value={value}
      onChange={onChange}
      className={classNames(styles.ProjectStatusSelector, className)}
    />
  );
};
